import "./RequestPasswordReset.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { RequestPasswordResetComponentController } from "./RequestPasswordResetComponentController";

export class RequestPasswordResetComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = RequestPasswordResetComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/ResetPassword/RequestReset/RequestPasswordReset.html";
    }
}
